import React from 'react'
import {IconButton as IconButtonUI, IconButtonProps} from 'wix-ui-tpa'
import {classes} from './icon-button.st.css'

export const IconButton: React.FC<IconButtonProps> = props => <IconButtonUI {...props} className={classes.root} />
